export const contactoMainBanner = [
    {
        image: './assets/imgs/nosotros/banner/fondo.png',
        color: '#000000',
        text: '<span>CONTACTO</span>',
      }

];

export const contactoMainBannerEn = [
    {
        image: './assets/imgs/nosotros/banner/fondo.png',
        color: '#000000',
        text: 'CONTACT',
      }
];